import EmailInput from '@op/components/EmailInput';
import moment from 'moment';
import React from 'react';
import { Form, Button } from 'tea-component';
import { useIntl, getLocale } from 'umi';

export default function GPTAutoReportForm({
  showEmailMessage,
  setShowEmailMessage,
  filter = {},
  emailList,
  setEmailList,
}: {
  showEmailMessage: boolean;
  setShowEmailMessage: (value: boolean) => void;
  filter: any;
  emailList: Array<string>;
  setEmailList: (value: Array<string>) => void;
}) {
  const { formatMessage } = useIntl();
  const language = getLocale();

  const { start_time, end_time } = filter;

  return (
    <Form.Item
      className="dbo-email-item"
      required
      label={formatMessage({ id: 'Email' })}
      showStatusIcon={false}
      status={showEmailMessage ? 'error' : undefined}
      message={
        <div>
          {showEmailMessage && (
            <p>
              {formatMessage({
                id: 'Please enter the correct email address',
              })}
            </p>
          )}

          {language === 'en-US' ? (
            <p className="text-tips-info">
              An English GPT report will be generated for you from{' '}
              <Button type="link" style={{ color: '#262832' }}>
                {start_time && moment(start_time).format('YYYY-MM-DD')}
              </Button>{' '}
              to{' '}
              <Button type="link" style={{ color: '#262832' }}>
                {end_time && moment(end_time).format('YYYY-MM-DD')}
              </Button>{' '}
              . Could you please confirm the email address to receive the
              report? You can click to{' '}
              <a
                target="_blank"
                href="https://databrain-global.intlgame.com/v2/opinion/gpt/GPT%20Auto%20Report?gameid=e1fe4bf56877e8604380470315d9553a9&start_time=2024-02-25&end_time=2024-02-25&language=en&kind=1&dateTab=Day"
              >
                view
              </a>{' '}
              the preview format.
            </p>
          ) : (
            <p className="text-tips-info">
              我们将为您生成一份从{' '}
              <Button type="link" style={{ color: '#262832' }}>
                {start_time && moment(start_time).format('YYYY-MM-DD')}
              </Button>{' '}
              到{' '}
              <Button type="link" style={{ color: '#262832' }}>
                {end_time && moment(end_time).format('YYYY-MM-DD')}
              </Button>{' '}
              的英文 GPT 报告。请确认接收报告的电子邮件地址。您可以点击
              <a
                target="_blank"
                href="https://databrain-global.intlgame.com/v2/opinion/gpt/GPT%20Auto%20Report?gameid=e1fe4bf56877e8604380470315d9553a9&start_time=2024-02-25&end_time=2024-02-25&language=en&kind=1&dateTab=Day"
              >
                预览
              </a>
              报告格式。
            </p>
          )}
        </div>
      }
    >
      <EmailInput
        value={emailList}
        placeholder={formatMessage({
          id: 'Please enter a Email',
        })}
        onChange={(tags, isError) => {
          setEmailList(tags);
          setShowEmailMessage(isError);
        }}
      />
    </Form.Item>
  );
}
